
import React, { useEffect, useState } from 'react'
import SelectMentor from './SelectMentor';
import { Route, Routes } from "react-router-dom";
import MentorList from './MentorList';
import { useSelector, useDispatch } from "react-redux";
import { addMentorInfo, resetClear } from "./redux/actions";
import { api } from "../../Services";
import { GetLogout } from '../modules/Logout';
import { resetState } from '../PersonalInfo/redux/actions';
import { resetIncome } from '../IncomeDetails/redux/actions';
import { resetEdu } from '../Education/redux/actions';
import { resetRegister } from '../Register/redux/actions';
import { resetApp } from '../ApplicationForm/redux/actions';
import { resetQueries } from '../Queries/redux/actions';
import { resetStatus } from '../WelcomeBack/redux/actions';
import { clearDisburse } from '../DisburseForm/redux/actions';
import { doLogout } from '../LoginPage/redux/actions';

function Mentors() {
  const [option, setOption] = useState(1);
  const dispatch= useDispatch()
  const tokenData = useSelector((state) => state.tokens.tokens);
  const personalInfo = useSelector((state) => state.personal.personalInfo);

  const getLogout = async () => {
    // const personalInfo = useSelector((state) => state.personal.personalInfo);
    // const dispatch = useDispatch();
    // const tokenData = useSelector((state) => state.tokens.tokens);

    try {
      let users = await api.logout(tokenData.token, personalInfo?.mobile);
      console.log('logout api', users)
      // if (users.statusCode == 200) {
        dispatch(resetState());
        dispatch(resetIncome());
        dispatch(resetEdu());
        dispatch(resetRegister());
        dispatch(resetApp());
        dispatch(resetQueries());
        dispatch(resetStatus());
        dispatch(clearDisburse());
        dispatch(resetClear());
        dispatch(doLogout());
      // }
      // return users;
    } catch (error) {
      console.error("Error logging out:", error);

      //   } finally {
      // setIsLoading(false);
    }
  };
  const logoutMsg = async () => {
    let users = await getLogout();
    console.log("logout api", users);
    console.log("u have been logged out");
  };
  const getMentors = async () => {
    let data={requiredHelpOn: null}
    try {
       const mentorData = await api.getFilteredMentors(tokenData.token, data);
     
      if (mentorData.statusCode == 200) {
        dispatch(addMentorInfo({type:'mentors', value:mentorData.data ?[...mentorData.data]:[]}));
      // }else{
      //   dispatch(addMentorInfo({type:'mentors', value:[]}));

      }else  if (
        mentorData.statusCode !== 200 &&
        mentorData.data.includes("Session expired")
      ) {
        logoutMsg();
      }
    } catch (err) {
      console.log("err", err);
      if (
        err?.data?.includes("Session expired")
      ) {
        logoutMsg();
      }
    }
  };

  useEffect(() => {
    getMentors()
  }, []);
  return (
    <div className='mentor-page'>
    
      <div className='mentor-options'>
        <div onClick={()=>setOption(1)} className={`option pointer ${option === 1 ? 'selected':''}`}>Find a mentor</div>
        <div onClick={()=>setOption(2)} className={`option pointer ${option === 2 ? 'selected':''}`}>My mentors</div>
        
      </div>
      {option === 1 ?
      <SelectMentor/>:
      <MentorList/>
      }
    </div>
  )
}

export default Mentors
